module.exports = __webpack_public_path__ + "img/user-icon.5589affc.svg";